import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';
import { Toast } from 'antd-mobile';
/**
 * 示例模块
 */
export default {
  namespace: 'meetingLanch',
  state: {
    switchCheck: false,
    dataSource: '',
  },
  reducers: {
    setDataSource(state, action) {
      return {
        ...state,
        dataSource: action.payload,
      };
    },
  },
  effects: {
    *sendDataSource(action, { put }) {
      const { params, callback = () => {} } = action.payload;
      const res = yield fetch.post(API.MEETING_CREATE, JSON.stringify(params));
      if (res.errorType && res.errorType === 'ERROR') {
        return Toast.fail(res.message);
      } else {
        if (callback && typeof callback === 'function') {
          callback(res);
        }
        console.error('setDataSource', res);
        yield put({
          type: 'setDataSource',
          payload: res,
        });
      }
    },
    *updateDataSource(action, { put }) {
      const { params, callback = () => {} } = action.payload;
      const res = yield fetch.post(API.MEETING_UPDATE, JSON.stringify(params));
      // if(res.errorType  && res.errorType === "ERROR"){
      //   callback(res);
      //  return Toast.fail(res.message);
      // }else{
      if (callback && typeof callback === 'function') {
        callback(res);
      }
      yield put({
        type: 'setDataSource',
        payload: res,
      });
      // }
    },
  },
};
